import React from "react";
import { useNavigate } from "react-router-dom";
import {
  HeroSection,
  TopListSection,
  NewDishSection,
  AppDownloadSection,
  ServicesSection,
  ScrollGallerySection,
  FinalCtaSection,
  FooterSection,
} from "../../components/visitor/sections/index.js";

/**
 * Page d'accueil visiteurs.
 * Version simplifiee: pas de fond fixe, pas d'overlays globaux.
 */
const VisitorHome = () => {
  const navigate = useNavigate();
  const goRecipes = () => navigate("/recipes");

  return (
    <div className="min-h-screen w-full paper-field">
      <HeroSection onViewRecipes={goRecipes} />

      <div className="w-full min-w-0 overflow-x-hidden px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto divide-y divide-ink-900/[0.07]">
        <TopListSection onViewRecipes={goRecipes} />
        <NewDishSection onViewRecipes={goRecipes} />
        <AppDownloadSection onViewRecipes={goRecipes} />
        <ServicesSection />
      </div>

      {/* Pas d'overflow-x-hidden ici : casserait le `position: sticky` utilisé
          par l'effet de scroll horizontal (voir ScrollGallerySection). */}
      <ScrollGallerySection />

      <div className="w-full min-w-0 overflow-x-hidden px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <FinalCtaSection />
      </div>

      <div className="w-full min-w-0 overflow-x-hidden px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <FooterSection onViewRecipes={goRecipes} />
      </div>
    </div>
  );
};

export default VisitorHome;
